import type { Canvas } from '=/types'
import type { Ref } from 'vue'

export function appendCanvasAnimated(element: Ref<HTMLCanvasElement | null>, data: Canvas) {
  const canvas = element.value
  if (!canvas) return

  const ctx = canvas.getContext('2d')

  canvas.width = 3240
  canvas.height = 2160

  const image = new Image()
  image.src = data.image

  image.onload = () => {
    const totalFrames = 5
    let currentFrame = 0

    const animate = () => {
      currentFrame++
      const progress = currentFrame / totalFrames

      ctx!.clearRect(0, 0, canvas.width, canvas.height)

      const pattern = ctx!.createPattern(image, 'repeat')

      if (pattern) {
        ctx!.globalAlpha = progress
        ctx!.fillStyle = pattern
        ctx!.fillRect(0, 0, canvas.width, canvas.height)
      }

      if (currentFrame < totalFrames) {
        requestAnimationFrame(animate)
      } else {
        ctx!.globalAlpha = 1
      }
    }

    requestAnimationFrame(animate)
  }
}
